import { Box, Flex } from '@chakra-ui/react';
import { HeadMeta } from 'components/HeadMeta';
import { getSharedPageProps } from 'components/Layout';
import { colors } from 'constants/constants';
import { GetStaticProps } from 'next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import SessionContext from 'session/SessionContext';

interface SignInProps {
  token: string;
}
export default function FinishSignUp(props: SignInProps): JSX.Element {
  const session = useContext(SessionContext);
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (session.actions.isSignInWithEmailLink(window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn');

      if (!email) {
        email = window.prompt('Please provide your email for confirmation');
      }

      if (!email) return;

      session.actions
        .signInWithEmailLink(email, window.location.href)
        ?.then((result) => {
          if (result.success) {
            router.replace('/mypages');
          } else {
            router.replace('/login');
          }
        });
    }
  }, []);

  return (
    <Flex pos="relative" justify="center" align="center" h="calc(100vh - 60px)">
      <HeadMeta nodeName="Logga in" />
      <Image src="/images/login.jpg" alt="Logga in" fill style={{ objectFit: 'cover' }} />

      <Box
        bg={colors.primary[900]}
        opacity={0.9}
        pos="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        zIndex="0"></Box>
    </Flex>
  );
}
export const getStaticProps: GetStaticProps = async () => {
  const sharedPageProps = await getSharedPageProps();

  return {
    props: { ...sharedPageProps },
  };
};
